import { Link } from "react-router-dom";
import HeroBreadcrumb from "@/components/layout/HeroBreadcrumb";
import { FileText, ExternalLink } from "lucide-react";

const ARCHIVIO = [
  { anno: "2020", url: "https://www.confcommercioroma.it/contributi-pubblici-archivio-2020/", tipo: "Pagina web" },
  { anno: "2021", url: "https://docs.google.com/document/d/108JZYtPaxETQ3oFpizKDoWXraiG0Dumq0ou68U4k4q0/edit", tipo: "Google Docs" },
  { anno: "2022", url: "https://docs.google.com/document/d/1zUeSvbFJ71YlWrVuulswy6uk0tWC25Wp6usrHMQRIVM/edit", tipo: "Google Docs" },
  { anno: "2023", url: "https://www.confcommercioroma.it/wp-content/uploads/2024/07/AIUTI-CEMAR-BC-SRL-2023.xlsx", tipo: "File Excel" },
];

export default function TrasparenzaPage() {
  return (
    <main id="main-content" data-testid="trasparenza-page">
      <section className="bg-[var(--confcom-blue)] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <HeroBreadcrumb />
          <h1 className="text-4xl md:text-5xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] tracking-tight">Trasparenza</h1>
          <p className="text-lg text-white/80 mt-4 max-w-3xl">Archivio delle pubblicazioni relative ai contributi pubblici ricevuti, in linea con gli obblighi normativi di trasparenza.</p>
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-[var(--confcom-text-secondary)] leading-relaxed mb-10">Qui sono disponibili i documenti suddivisi per anno che riportano i dettagli delle sovvenzioni, sussidi e altri benefici pubblici ricevuti dall'Associazione. L'obiettivo e garantire una gestione aperta e responsabile delle informazioni, favorendo la correttezza e la legalita.</p>

          <h2 className="text-xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-6">Archivio pubblicazioni</h2>
          <div className="grid sm:grid-cols-2 gap-4 mb-12">
            {ARCHIVIO.map((a) => (
              <a key={a.anno} href={a.url} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-4 p-5 rounded-xl border border-[var(--confcom-border)] hover:border-[var(--confcom-blue)]/30 hover:shadow-md transition-all" data-testid={`trasparenza-${a.anno}`}>
                <div className="w-12 h-12 bg-[var(--confcom-bg-blue-light)] rounded-xl flex items-center justify-center shrink-0 group-hover:bg-[var(--confcom-blue)] transition-colors">
                  <FileText size={22} className="text-[var(--confcom-blue)] group-hover:text-white transition-colors" aria-hidden="true" />
                </div>
                <div className="flex-1">
                  <div className="text-lg font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] group-hover:text-[var(--confcom-blue)] transition-colors">{a.anno}</div>
                  <div className="text-xs text-[var(--confcom-text-muted)]">{a.tipo}</div>
                </div>
                <ExternalLink size={16} className="text-[var(--confcom-text-muted)] group-hover:text-[var(--confcom-blue)] transition-colors" aria-hidden="true" />
              </a>
            ))}
          </div>

          <div className="p-6 bg-[var(--confcom-bg-subtle)] rounded-xl border border-[var(--confcom-border)]">
            <h3 className="text-base font-semibold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-2">Per maggiori informazioni</h3>
            <p className="text-sm text-[var(--confcom-text-secondary)]">Per qualsiasi richiesta relativa ai documenti della trasparenza, segnalazioni o chiarimenti:</p>
            <p className="text-sm text-[var(--confcom-text-secondary)] mt-2"><strong>Email:</strong> info@confcommercioroma.it | <strong>Tel:</strong> 066 843 7620</p>
            <p className="text-sm text-[var(--confcom-text-secondary)]"><strong>Indirizzo:</strong> Via Marco e Marcelliano, 45 - 00147 Roma</p>
          </div>
        </div>
      </section>
    </main>
  );
}
